import { jsx as I, Fragment as l, jsxs as i } from "@emotion/react/jsx-runtime";
import { css as t } from "@emotion/react";
import { desktopFirstMediaQuery as A } from "@inflearn/ds-react";
import { u as b, b2 as n, c as e } from "./StickyHeaderSkeleton-a6cd75ca.mjs";
import "@mantine/core";
import "react";
import "react/jsx-runtime";
import "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/plugin/localizedFormat";
import "dayjs/plugin/updateLocale";
import "@inflearn/datasource-rest";
import "@tanstack/react-query";
import "@inflearn/analytics";
import "@mantine/hooks";
const c = 157, g = `${e}/assets/channeltalk/channeltalk.png?w=${c * 2}`;
function W() {
  const {
    t: C
  } = b();
  return /* @__PURE__ */ I(l, { children: /* @__PURE__ */ I("a", { href: n, target: "_blank", className: "channel-talk__redirect-button", css: X, rel: "noreferrer", children: /* @__PURE__ */ i("picture", { children: [
    /* @__PURE__ */ I("source", { srcSet: `${g}&f=avif`, type: "image/avif" }),
    /* @__PURE__ */ I("source", { srcSet: `${g}&f=webp`, type: "image/webp" }),
    /* @__PURE__ */ I("img", { src: g, alt: C("채널톡 아이콘") })
  ] }) }) });
}
const X = /* @__PURE__ */ t({
  position: "fixed",
  zIndex: 9999,
  bottom: "50px",
  right: "18px",
  display: "flex",
  flexWrap: "nowrap",
  WebkitBoxAlign: "center",
  alignItems: "center",
  WebkitBoxPack: "center",
  justifyContent: "center",
  width: `${c}px`,
  height: "74px",
  [A.tablet]: {
    display: "none"
  },
  picture: {
    width: "100%",
    height: "100%"
  },
  img: {
    width: "100%",
    height: "100%"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
export {
  W as ChannelTalk
};
